import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const CustomerFilters = ({ 
  searchQuery, 
  onSearchChange, 
  statusFilter, 
  onStatusChange,
  aduTypeFilter,
  onAduTypeChange,
  leadSourceFilter,
  onLeadSourceChange,
  resultCount 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'inquiry', label: 'Inquiry' },
    { value: 'planning', label: 'Planning' },
    { value: 'permits', label: 'Permits' },
    { value: 'construction', label: 'Construction' },
    { value: 'completed', label: 'Completed' }
  ];

  const aduTypeOptions = [
    { value: 'all', label: 'All ADU Types' },
    { value: 'detached', label: 'Detached' },
    { value: 'attached', label: 'Attached' },
    { value: 'garage_conversion', label: 'Garage Conversion' },
    { value: 'basement_conversion', label: 'Basement Conversion' }
  ];

  const leadSourceOptions = [
    { value: 'all', label: 'All Lead Sources' },
    { value: 'website', label: 'Website' },
    { value: 'referral', label: 'Referral' },
    { value: 'social_media', label: 'Social Media' },
    { value: 'trade_show', label: 'Trade Show' },
    { value: 'direct_mail', label: 'Direct Mail' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm mb-4 md:mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="Search customers..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
        </div>

        <Select
          placeholder="Filter by status"
          options={statusOptions}
          value={statusFilter}
          onChange={onStatusChange}
        />

        <Select
          placeholder="Filter by ADU type"
          options={aduTypeOptions}
          value={aduTypeFilter}
          onChange={onAduTypeChange}
        />

        <Select
          placeholder="Filter by lead source"
          options={leadSourceOptions}
          value={leadSourceFilter}
          onChange={onLeadSourceChange}
        />
      </div>
      <div className="mt-4 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{resultCount}</span> customer{resultCount !== 1 ? 's' : ''}
        </p>
      </div>
    </div>
  );
};

export default CustomerFilters;